import { createApi } from '@reduxjs/toolkit/query/react';
import { createAppBaseQuery } from '../../services/baseQuery';

export const profileApi = createApi({
  reducerPath: 'profileApi',
  baseQuery: createAppBaseQuery(),
  tagTypes: ['Profile'],
  endpoints: (builder) => ({
    getProfile: builder.query({
      query: () => '/users/me',
      providesTags: ['Profile'],
    }),
    updateProfile: builder.mutation({
      query: (body) => ({ url: '/users/me', method: 'PATCH', body }),
      invalidatesTags: ['Profile'],
    }),
    getReputation: builder.query({
      query: (publicId) => `/users/${publicId}/reputation`,
    }),
  }),
});

export const { useGetProfileQuery, useUpdateProfileMutation, useGetReputationQuery } = profileApi;
